import httpClient from "./httpClient";

export const getCompany = async () => {
  return await httpClient.get("/api/company");
};
